import { render, staticRenderFns } from "./HotNews.vue?vue&type=template&id=f914b2b6&"
import script from "./HotNews.vue?vue&type=script&lang=js&"
export * from "./HotNews.vue?vue&type=script&lang=js&"
import style0 from "./HotNews.vue?vue&type=style&index=0&lang=css&"
import style1 from "./HotNews.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports